"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// 面板组件
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = props.children,
      mountTarget = props.mountTarget,
      _props$portalClassNam = props.portalClassName,
      portalClassName = _props$portalClassNam === void 0 ? '' : _props$portalClassNam,
      _props$containerClass = props.containerClassName,
      containerClassName = _props$containerClass === void 0 ? '' : _props$containerClass,
      _props$containerStyle = props.containerStyle,
      containerStyle = _props$containerStyle === void 0 ? {} : _props$containerStyle;
  var result = null,
      portalProps = {}; // 下拉面板结构，如果是挂载在body或者自定义结构，需要多加一层

  if (mountTarget === 'body' || _typeof(mountTarget) === 'object') {
    if (_typeof(mountTarget) === 'object') {
      portalProps.target = mountTarget;
    }

    result = _react["default"].createElement(_spauiPortal["default"], _extends({
      className: portalClassName + ' spaui-select-portal'
    }, portalProps), _react["default"].createElement("div", {
      className: containerClassName,
      style: _objectSpread({}, containerStyle)
    }, children));
  } else {
    result = children;
  }

  return result;
};

exports["default"] = _default;